const getVideoStatusLabelKey = ({ hasError, compact }) => {
  if (hasError) return compact ? 'videoStatusFailedShort' : 'videoStatusFailed';
  return compact ? 'videoStatusProcessingShort' : 'videoStatusProcessing';
};

export default getVideoStatusLabelKey;
